'use strict'
//创建对象 var sig = new LsmpSdkRtcSignaling();
export function HwRtcSignaling() {
  //创建内部对象
  var self = {}
  self._tempSigData = {
    //map对象： Key是tid, value是Promise对象.
    promiseMap: {},
  }

  self.websocket = null //ws对象
  self.websocketFlag = false //避免ws重复连接
  self.debugLog = false

  self.myTokenInfo = {}
  self.myToken = null //服务器分配的令牌
  self.roomInfo = {} //定义了一个房间信息对象。
  self.reqPublishResInfo = {} //定义了一个发布结果对象

  //设置打印日志
  self.openDebug = function() {
    self.debugLog = true
  }

  //连接。async函数，会返回一个Promise对象
  self.sigConnect = async function(url_prefix, room, clientCode, tokenMode) {
    var wsUrl = url_prefix + '?room=' + room + '&clientCode=' + clientCode + '&tokenMode=' + tokenMode
    if ('WebSocket' in window) {
      try {
        if (self.websocket) {
          if (self.debugLog) {
            console.log('sig websocket exists, need close.')
          }
          self.websocket.close()
        }

        self.websocket = null
        self.websocketFlag = false

        //ws连接. 这个是异步方法. 等待回调
        self.websocket = new WebSocket(wsUrl)
      } catch (e) {
        return new Promise(function(resolve, reject) {
          console.log('sig connect error!')
          reject(false)
        })
      }

      //定义回调
      self.websocket.onclose = function(event) {
        self.websocket = null
        self.websocketFlag = false
        console.log('sig connect close!')
      }
      self.websocket.onmessage = function(event) {
        self.callbackOnMessage(event)
      }

      return new Promise(function(resolve, reject) {
        //定义Promise内的监听
        self.websocket.onopen = function(event) {
          console.log('sig connect ok!')
          self.websocketFlag = true //异步回调.这个写法是可以修改到对象属性的
          resolve(true)
        }

        self.websocket.onerror = function(event) {
          console.log('sig ws onerror!')
          reject(false)
        }
      })
    }
    return new Promise(function(resolve, reject) {
      console.log('sig connect error!')
      reject(false)
    })
  }

  //关闭。直接返回
  self.sigClose = function() {
    if (self.websocket) {
      self.websocket.close()
    }
    self.websocket = null
    self.websocketFlag = false
  }

  //检查sig连接，直接返回
  self.sigCheckAlive = function() {
    if (self.websocket && self.websocketFlag) {
      self.websocket.close()
      return true
    }
    return false
  }

  //发送消息通用格式。 结果异步返回
  self.sigSend = function(tid, action, msg) {
    if (self.websocket && self.websocketFlag) {
      try {
        var jsonObj = {}
        if (msg) {
          jsonObj = { tid: tid, action: action, data: msg }
        } else {
          jsonObj = { tid: tid, action: action }
        }
        self.websocket.send(JSON.stringify(jsonObj))
      } catch (e) {}
    }
  }

  //发送信令前先获取tid
  self.genSigId = function() {
    return Number(parseInt(new Date().getTime() * Math.random() * 100))
      .toString(16)
      .substr(0, 9)
  }

  //查询Token。 业务端调用方式：sig.myToken = await sig.sigQueryToken();
  self.sigQueryToken = async function() {
    if (self.debugLog) {
      console.log('sigQueryToken...websocketFlag==' + self.websocketFlag)
    }
    return new Promise(function(resolve, reject) {
      var tid = self.genSigId()
      self._tempSigData.promiseMap[tid] = { resolve: resolve, reject: reject }
      self.sigSend(tid, 'queryToken')
    })
  }

  //查询房间信息。 业务端调用方式：sig.roomInfo = await sig.sigQueryRoom();
  self.sigQueryRoom = async function() {
    if (self.debugLog) {
      console.log('sigQueryRoom...websocketFlag==' + self.websocketFlag)
    }
    return new Promise(function(resolve, reject) {
      var tid = self.genSigId()
      self._tempSigData.promiseMap[tid] = { resolve: resolve, reject: reject }
      self.sigSend(tid, 'queryRoom')
    })
  }

  //请求断开ws连接 await sig.sigReqDisconnect();
  self.sigReqDisconnect = async function() {
    if (self.debugLog) {
      console.log('sigReqDisconnect...websocketFlag==' + self.websocketFlag)
    }
    return new Promise(function(resolve, reject) {
      var tid = self.genSigId()
      self.sigSend(tid, 'reqDisconnect')

      self.websocket = null
      self.websocketFlag = false
    })
  }

  //请求推流。 业务端调用方式：sig.reqPublishResInfo = await sig.sigReqPublish();
  self.sigReqPublish = async function(paramJson) {
    if (self.debugLog) {
      console.log('sigReqPublish...websocketFlag==' + self.websocketFlag)
    }
    return new Promise(function(resolve, reject) {
      var tid = self.genSigId()
      //放入缓存。结果会直接返回给调用方
      self._tempSigData.promiseMap[tid] = { resolve: resolve, reject: reject }
      self.sigSend(tid, 'reqPublish', paramJson)
    })
  }

  //回调: 消息回调
  self.callbackOnMessage = function(event) {
    if (event && event.data) {
      try {
        var jsonMsg = JSON.parse(event.data)
        var promise = self._tempSigData.promiseMap[jsonMsg.tid]
        if (promise) {
          //缓存中找到promise对象
          promise.resolve(jsonMsg.data)
          delete self._tempSigData.promiseMap[jsonMsg.tid]
        } else {
          //不是下发的请求
          var actionTxt = jsonMsg.action
          if (actionTxt == 'heartbeat') {
            //服务器心跳
            if (self.debugLog) {
              console.log('sig onmessage. heartbeat...')
            }
          } else if (actionTxt == 'notify') {
            //服务器主动通知
            self.sigServerNotify(jsonMsg)
          } else {
            console.log('sig msg callback, no handler!')
          }
        }
      } catch (e) {
        console.log('sig onmessage... error json!!')
      }
    } else {
      if (self.debugLog) {
        console.log('sig onmessage... error data!!')
      }
    }
  }

  //服务器回调-->新客户加入
  self.sigServerNotify = function(jsonMsg) {
    var eventTxt = jsonMsg.data.event
    if (self.debugLog) {
      console.log('sigServer Notify event=' + eventTxt)
    }
    if (eventTxt) {
      if (eventTxt == 'clientJoin') {
        //新客户加入
        self.sigServerNotifyClientJoin(jsonMsg)
      } else if (eventTxt == 'clientPublish') {
        //客户端推流
        self.sigServerNotifyClientPublish(jsonMsg)
      } else if (eventTxt == 'clientLeave') {
        //客户离开会议
        self.sigServerNotifyClientLeave(jsonMsg)
      } else {
        console.log('sig msg notify callback, no handle this event!')
      }
    }
  }

  //服务器回调-->新客户加入（业务端可以重写此方法）
  self.sigServerNotifyClientJoin = function(jsonMsg) {
    if (self.debugLog) {
      console.log('sigServer Notify ClientJoin...')
    }
  }

  //服务器回调-->客户端推流
  self.sigServerNotifyClientPublish = function(jsonMsg) {
    if (self.debugLog) {
      console.log('sigServer Notify ClientPublish...')
    }
    if (jsonMsg && jsonMsg.data) {
      self.sigServerNotifyClientPublishChange(jsonMsg.data)
    }
  }

  //服务器回调-->客户离开会议
  self.sigServerNotifyClientLeave = function(jsonMsg) {
    if (self.debugLog) {
      console.log('sigServer Notify ClientLeave...')
    }
    if (jsonMsg && jsonMsg.data) {
      self.sigServerNotifyClientPublishChange(jsonMsg.data)
    }
  }

  //服务器通知房间内推流客户端有变化, 由业务端重写此方法
  self.sigServerNotifyClientPublishChange = function(roomInfoJson) {
    console.log('please override the function [sig.sigServerNotifyClientPublishChange=function(json)]')
    //业务端只需重写方法只需加上这一段
    if (roomInfoJson) {
      self.roomInfo = roomInfoJson
    }
  }

  //new 一个对象
  return self
}
